import _ from "lodash";
import { WEB_PORTAL_URL } from "@constant";

export const validateEmail = (email) => {
  var re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export function validatePhoneNumbers(value) {
  let re = /^\+\d{1,4} \d{6,14}$/;

  return re.test(value);
}

export const validateUrl = (url) => {
  let re =
    /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}(?:\/[^\s]*)?$/;

  // "http://example.com",
  // "https://www.example.com",
  // "http://subdomain.example.com",
  // "https://subdomain.example.com",
  // "http://www.subdomain.example.com",
  // "https://www.subdomain.example.com",
  // "http://example.com/path/to/resource",
  // "https://www.example.com/path/to/resource",
  // "http://subdomain.example.com/path/to/resource",
  // "https://subdomain.example.com/path/to/resource",
  // "http://www.subdomain.example.com/path/to/resource",
  // "https://www.subdomain.example.com/path/to/resource",
  // "http://example-domain.com",
  // "http://subdomain.example-domain.com",
  // "http://www.subdomain.example-domain.com",
  // "www.uco.co.in",
  // "http://www.uco.co.in",
  // "https://www.uco.co.in",
  // "https://app.eventify.io/assets/exhibitor_logo.jpg",
  // "http://app.eventify.io/assets/exhibitor_logo.jpg",
  // "www.app.eventify.io/assets/exhibitor_logo.jpg";

  return re.test(url);
};

export const validateOnlyNums = (value) => {
  // return value.replace(/[^\d]/g, "");
  // let check = !isNaN(value);
  var re = /^\d+$/;
  var check = re.test(value);

  return check;
};

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function checkDateFormatYMD(date) {
  // console.log("date :- ", date);
  var regex = new RegExp(/[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/);

  return regex.test(date);
}

export function priceDisplayLocally(price) {
  let options = {
    style: "decimal", // Other options: 'currency', 'percent', etc.
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
  let pr = price.toLocaleString(
    navigator.language || navigator.userLanguage,
    options
  );
  return pr;
}

export function getValidFileName(filename) {
  let split = filename.split(".");
  let ext = split.pop();
  let newFname = split.join();

  // Remove special symbols and extra spaces and replace with '_'
  // newFname = "a@A9 8_)  *AÀA(Ań.";
  let newFnm = newFname.replace(/[^A-Z0-9]/gi, "_");
  let fileName = newFnm + "." + ext;

  return fileName;
}

export function generateFileName(filename) {
  let dynamic = Date.now();
  let split = filename.split(".");
  let ext = split.pop();
  let newFname = split.join();

  let fileName = newFname + "_" + dynamic + "." + ext;

  return fileName;
}

export function getFileDataArray(files) {
  let filesArray = [];
  files.forEach((file) => {
    let f1 = file.split("/").pop();
    let ext = f1.split(".").pop();
    let f2 = f1.substr(0, f1.lastIndexOf("_"));
    let fileName = f2 + "." + ext;

    filesArray.push({ file: file, filename: fileName });
  });

  return filesArray;
}

export const numberConversion = (value) => {
  if (typeof value === "string") return _.toNumber(value);
  else return value;
};

export const formUpFullName = (fName, lName) => {
  const bothPresent = !_.isEmpty(fName) && !_.isEmpty(lName);

  return `${fName}${bothPresent ? " " : ""}${lName}`;
};

export const isJSONParsable = (strVal) => {
  try {
    JSON.parse(strVal);
  } catch (e) {
    return false;
  }

  return true;
};

export function calculateAverageScore(scores) {
  // Normalize scores to a common denominator (out of 1)
  const normalizedScores = scores.map(([score, max]) => score / max);
  // Calculate the average of normalized scores
  const average = _.mean(normalizedScores);
  // Returning the average as a score out of 10
  return _.round(average * 10, 2);
}

export const webportalURL = (seocode) => {
  return _.includes(window.location.hostname, "eventify.io") ||
    _.includes(window.location.href, "localhost:3000")
    ? WEB_PORTAL_URL.replace(`{seocode}`, seocode)
    : `https://${seocode}`;
};

export const detectBrowser = () => {
  const nAgt = navigator.userAgent;

  const browsers = [
    { name: "Opera", pattern: /OPR\/([\d.]+)/ },
    { name: "Opera", pattern: /Opera\/([\d.]+)|Version\/([\d.]+)/ },
    { name: "Microsoft Internet Explorer", pattern: /MSIE ([\d.]+)/ },
    { name: "Chrome", pattern: /Chrome\/([\d.]+)/ },
    { name: "Safari", pattern: /Safari\/([\d.]+)|Version\/([\d.]+)/ },
    { name: "Firefox", pattern: /Firefox\/([\d.]+)/ },
  ];

  const formatBrowserInfo = (name, version) => ({
    platform: "web",
    devicename: name,
    model: name,
    systemversion: version,
    version,
    device: "",
    build: "",
    eventid: 0,
  });

  for (const { name, pattern } of browsers) {
    const match = nAgt.match(pattern);
    if (match) {
      return formatBrowserInfo(name, match[1] || match[2]);
    }
  }

  const fallbackMatch = nAgt.match(/(\w+)\/([\d.]+)$/);
  const fallbackName = fallbackMatch ? fallbackMatch[1] : navigator.appName;
  const fallbackVersion = fallbackMatch
    ? fallbackMatch[2]
    : navigator.appVersion;

  return formatBrowserInfo(fallbackName, fallbackVersion);
};
